import React from 'react';

import cx from 'classnames';

import Icon from 'components/shared/Icon';
import Group from 'components/shared/Icon/icons/Group';
import { useLandingNavigation } from 'hooks/useLandingNavigation';
import i18n from 'i18n';

import styles from './index.module.css';
import Item from './Item';
import itemStyles from './Item/index.module.css';

function FormBuilderNav(props) {
  const { links, isItinerariesItem, landingTheme, isLoading } = props;
  const { getBaseOffset, handleLinkClick } = useLandingNavigation({
    isItinerariesItem,
    elemId: 'pageHeadline',
    type: 'builderNav',
    landingTheme,
  });

  return (
    <div className={cx(styles.wrapper, 'custom-landing-page-nav', isLoading && styles.loading)}>
      <div className={styles.items}>
        <div className={itemStyles.item}>
          <div className={styles.head}>
            <Icon component={Group} className={styles.icon} />
            <div className={styles.title}>{i18n.t('proposal_content.table_of_contents')}</div>
          </div>
        </div>

        {links.map((link, i) => (
          <Item
            key={i}
            link={link}
            index={i}
            getBaseOffset={getBaseOffset}
            handleLinkClick={handleLinkClick}
            isItinerariesItem={isItinerariesItem}
          />
        ))}
      </div>
    </div>
  );
}

export default FormBuilderNav;
